import React from "react";
import "./loader.css";

const Loader = () => {
  return (
    <div className="span">
      <div className="help"></div>
    </div>
  );
};

export default Loader;
